export const minPasswordStrength = 2E12